import * as hierarchyActions from "contexts/hierarchy/interface";

/**
 * Determines whether a hierarchy action can change the singles or domain replacements,
 * meaning their save blockers must be re-derived from the reduced hierarchy.
 *
 * @param action - The hierarchy action being applied.
 * @returns `true` when the singles and domain replacement blockers need recalculating.
 */
export const shouldRebuildDerivedSaveBlockers = (
  action: hierarchyActions.IHierarchyAction,
): boolean => {
  return new Set([
    hierarchyActions.ADD_DOMAIN_REPLACEMENT,
    hierarchyActions.ADD_SINGLE_REPLACEMENT,
    hierarchyActions.REMOVE_DOMAIN_REPLACEMENT,
    hierarchyActions.REMOVE_SINGLE_REPLACEMENT,
    hierarchyActions.SAVE_HIERARCHY_COMPLETED,
    hierarchyActions.UPDATE_DOMAIN_REPLACEMENT,
    hierarchyActions.UPDATE_HIERARCHY,
    hierarchyActions.UPDATE_SINGLE_REPLACEMENT,
  ]).has(action.operation);
};
